/*
 * @Description:
 * @Author: Leyton
 * @LastEditors: Leyton
 * @LastEditTime: 2022-06-10 10:58:05
 * @FilePath: /91qs_answer_frontpro/src/components/layout/js/countdown.js
 */
import React, { useState, useEffect, useRef } from "react";
import { Button } from "antd";

const Countdown = ({
  countdown,
  themeColor,
  className,
  btnText,
  ...others
}) => {
  const [time, setTime] = useState(countdown);
  const countRef = useRef(countdown);
  useEffect(() => {
    countRef.current = countdown;
    let timer = null;
    const innerFun = () => {
      timer = setTimeout(() => {
        if (countRef.current > 1) {
          countRef.current--;
          setTime(countRef.current);
          innerFun();
          return;
        }
        return setTime(0);
      }, 1000);
    };
    innerFun();
    return () => clearTimeout(timer);
  }, [countdown]);

  // const childProps = get(children, 'props', {});
  return (
    // React.cloneElement(children, {...childProps, dangerouslySetInnerHTML:{ __html: nextButton || '&gt;' }})
    <Button
      className={className}
      {...others}
      type="primary"
      style={{ background: themeColor }}
      disabled={time > 0}
    >
      {time > 0 ? `${time}s` : btnText}
    </Button>
  );
};

export default Countdown;
